import { z } from "zod";
export const SmsStopWebhookQuerySchema = z.object({ secret: z.string().min(32).max(256) });
export const SmsStopWebhookPayloadSchema = z.unknown();
//# sourceMappingURL=smsStopWebhook.types.js.map